import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let Icon;
  try {
    Icon = icon || (name && FiIcons[`Fi${name}`]);
  } catch {
    Icon = null;
  }
  return Icon
    ? React.createElement(Icon, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;